/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_Reps_MaxInputs */

const en_us2_plan_build_dose_reps_max = /** @type {(inputs: Plan_Build_Dose_Reps_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps (maximum)`)
};

const pt_br2_plan_build_dose_reps_max = /** @type {(inputs: Plan_Build_Dose_Reps_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições (máximo)`)
};

const es_419_plan_build_dose_reps_max = /** @type {(inputs: Plan_Build_Dose_Reps_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeticiones (máximo)`)
};

const pt_pt2_plan_build_dose_reps_max = /** @type {(inputs: Plan_Build_Dose_Reps_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições (máximo)`)
};

const fr_fr2_plan_build_dose_reps_max = /** @type {(inputs: Plan_Build_Dose_Reps_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions (maximum)`)
};

const de_de2_plan_build_dose_reps_max = /** @type {(inputs: Plan_Build_Dose_Reps_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdh. (Maximum)`)
};

const it_it2_plan_build_dose_reps_max = /** @type {(inputs: Plan_Build_Dose_Reps_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetizioni (massimo)`)
};

/**
* | output |
* | --- |
* | "Reps (maximum)" |
*
* @param {Plan_Build_Dose_Reps_MaxInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_reps_max = /** @type {((inputs?: Plan_Build_Dose_Reps_MaxInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_Reps_MaxInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_reps_max(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_reps_max(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_reps_max(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_reps_max(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_reps_max(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_reps_max(inputs)
	return en_us2_plan_build_dose_reps_max(inputs)
});
export { plan_build_dose_reps_max as "plan-build.dose_reps_max" }